import { LAYOUT_NOTES, PAYWALL_NOTES } from './constants/campaign-notes';
import {
  REGISTRATION_PLATFORM,
  WebCampaignKeyType,
  WebCampaignType,
} from './global';

export const CAMPAIGNS_SETUP: Record<WebCampaignKeyType, WebCampaignType> = {
  devmode: {
    layout: 'devmode',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'devmode',
    paywallNotes: [],
    paywallImagesVariant: null,
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: ['pro.1w', 'pro.1m', 'pro.3m', 'pro.1y'],
    coins: [],
    defaultPlan: 'pro.1m',
    rejectPrepaidCards: false,
    preferencesVariant: 'default',
    animated: false,
    staticTheme: null,
    successPage: 'devmode',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: null,
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  MyCkd1: {
    layout: 'replika-short',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'v1',
    paywallNotes: [],
    paywallImagesVariant: null,
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: ['pro.1w', 'pro.1m', 'pro.1y'],
    coins: [],
    defaultPlan: 'pro.1y',
    rejectPrepaidCards: false,
    preferencesVariant: 'default',
    animated: false,
    staticTheme: null,
    successPage: 'default',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  MyCkd1NA: {
    layout: 'replika-short-no-ai',
    layoutNotes: [],
    theme: 'light',
    paywall: 'default-short',
    paywallNotes: [],
    paywallImagesVariant: null,
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: ['pro.1w', 'pro.1m', 'pro.1y'],
    coins: [],
    defaultPlan: 'pro.1y',
    rejectPrepaidCards: false,
    preferencesVariant: 'default',
    animated: false,
    staticTheme: null,
    successPage: 'default',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: 'Ugly campaign',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  Fy8m4P1: {
    layout: 'replika-user-data-relationships',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'v2',
    paywallNotes: [],
    paywallImagesVariant: null,
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: ['pro.1w', 'pro.1m', 'pro.1y'],
    coins: [],
    defaultPlan: 'pro.1y',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'default',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjed: {
    layout: 'own-ai',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedTG: {
    layout: 'own-ai-trans',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs',
    paywallNotes: [PAYWALL_NOTES.FIXED_TIMER, PAYWALL_NOTES.TRANS],
    paywallImagesVariant: 'transsexual',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'trans',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-791',
    comment: 'Trans Funnel',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedTT1: {
    layout: 'own-ai-ons',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs',
    paywallNotes: [],
    paywallImagesVariant: 'one-night-stand',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-790',
    comment: 'One-night stand for TT Funnel',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedWA: {
    layout: 'own-ai',
    layoutNotes: [],
    theme: 'dark',
    paywall: null,
    paywallNotes: [],
    paywallImagesVariant: null,
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2349',
    comment: 'Campaign with auth link to web app',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34FsGrAIPh: {
    layout: 'own-ai-FsGrAIPh',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2318',
    comment: 'First screen with AI phrase',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34FsGrFlAI: {
    layout: 'own-ai-FsGrFlAI',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2318',
    comment: 'First screen with full AI',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34FsGrAITl: {
    layout: 'own-ai-FsGrAITl',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2318',
    comment: 'First screen with AI`s tiles',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedICaTO: {
    layout: 'own-ai-ICaTO',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2326',
    comment: 'Interactive chat component after Major Turn Off screen',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedICbEm: {
    layout: 'own-ai-ICbEm',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2326',
    comment: 'Interactive chat screen before Email screen',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedICaEm: {
    layout: 'own-ai-ICaEm',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2326',
    comment: 'Interactive chat screen after Email screen',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedHcDrw: {
    layout: 'own-ai',
    layoutNotes: [LAYOUT_NOTES.HAIR_COLOR_DRAWN],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [PAYWALL_NOTES.STORE_IMAGES],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2325',
    comment: 'Updated hair color screen with drawn images',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedThScN: {
    layout: 'own-ai',
    layoutNotes: [LAYOUT_NOTES.THREE_SCREENS_NEW],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2317',
    comment: 'new girls on first three screens',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedd: {
    layout: 'own-ai-domination',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-domination',
    paywallNotes: [PAYWALL_NOTES.FIXED_TIMER],
    paywallImagesVariant: null,
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: 'domination',
    successPage: 'domination',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2673',
    comment: 'Dominant onb',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjeddBR1: {
    layout: 'own-ai-domination-v2',
    layoutNotes: [LAYOUT_NOTES.JIA],
    theme: 'dark',
    paywall: 'fast-pay-tabs-domination',
    paywallNotes: [PAYWALL_NOTES.FIXED_TIMER, PAYWALL_NOTES.JIA],
    paywallImagesVariant: null,
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: 'domination',
    successPage: 'domination',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-724',
    comment: 'New Dominant funnels Jia',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjeddBR2: {
    layout: 'own-ai-domination-v2',
    layoutNotes: [LAYOUT_NOTES.JIA, LAYOUT_NOTES.WELCOME_V2],
    theme: 'dark',
    paywall: 'fast-pay-tabs-domination',
    paywallNotes: [PAYWALL_NOTES.FIXED_TIMER, PAYWALL_NOTES.JIA],
    paywallImagesVariant: null,
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: 'domination',
    successPage: 'domination',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-724',
    comment: 'New Dominant funnels Jia V2 welcome screen',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjeddLCY: {
    layout: 'own-ai-domination-v2',
    layoutNotes: [LAYOUT_NOTES.LUCY],
    theme: 'dark',
    paywall: 'fast-pay-tabs-domination',
    paywallNotes: [PAYWALL_NOTES.FIXED_TIMER, PAYWALL_NOTES.LUCY],
    paywallImagesVariant: null,
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: 'domination',
    successPage: 'domination',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-724',
    comment: 'New Dominant funnels Lucy',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMn: {
    layout: 'own-ai-man',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnCe: {
    layout: 'own-ai-man-ce',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [
      PAYWALL_NOTES.APP_ICON_BG,
      PAYWALL_NOTES.PROMO_CODE,
      PAYWALL_NOTES.PROD_2506,
    ],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2548',
    comment: 'Man w2w with combination of elements',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMn_FLs: {
    layout: 'own-ai-man-fls',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2516',
    comment: 'First loader screen',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnScS: {
    layout: 'own-ai-man-scs',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2519',
    comment: 'Self-confidence screens',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnSPaE: {
    layout: 'own-ai-man-SPaE',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2518',
    comment: 'Social proof screen after email',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnSPaN: {
    layout: 'own-ai-man-SPaN',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2518',
    comment: 'Social proof screen after name',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnLSaN: {
    layout: 'own-ai-man-LSaN',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2517',
    comment: 'Loneliness screens after name',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnNf: {
    layout: 'own-ai-man',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG, PAYWALL_NOTES.PROD_2506],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2506',
    comment: 'Man`s campaign with updated photos',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnWV: {
    layout: 'own-ai-man',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnICbEm: {
    layout: 'own-ai-man-ICbEm',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2412',
    comment: 'Interactive chat screen before Email screen',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnLS: {
    layout: 'own-ai-man-ls',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.FIXED_TIMER],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2676',
    comment: 'New 4 loneliness screens for man w2w',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnICaEm: {
    layout: 'own-ai-man-ICaEm',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2412',
    comment: 'Interactive chat screen after Email screen',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnICaTO: {
    layout: 'own-ai-man-ICaTO',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2412',
    comment: 'Interactive chat component after Major Turn Off screen',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnPTm: {
    layout: 'own-ai-man',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.FIXED_TIMER],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2411',
    comment: 'Campaign for man with timer',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnPTm9_19: {
    layout: 'own-ai-man',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.FIXED_TIMER],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1026',
    comment: 'Replace intro offer 6.99->39.99 with a plan week for $9.99',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnPTmg3: {
    layout: 'own-ai-man-g',
    layoutNotes: [LAYOUT_NOTES.WelcomeG3],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.FIXED_TIMER],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-499',
    comment: 'w2w funnel pride with g3 screen',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnPTmg5: {
    layout: 'own-ai-man-g',
    layoutNotes: [LAYOUT_NOTES.WelcomeG5],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.FIXED_TIMER],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-499',
    comment: 'w2w funnel pride with g5 screen',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnPTmg6: {
    layout: 'own-ai-man-g',
    layoutNotes: [LAYOUT_NOTES.WelcomeG6],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.FIXED_TIMER],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-499',
    comment: 'w2w funnel pride with g6 screen',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnPTmg9: {
    layout: 'own-ai-man-g',
    layoutNotes: [LAYOUT_NOTES.WelcomeG9],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.FIXED_TIMER],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-499',
    comment: 'w2w funnel pride with g9 screen',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnPTmg12: {
    layout: 'own-ai-man-g',
    layoutNotes: [LAYOUT_NOTES.WelcomeG12],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.FIXED_TIMER],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-499',
    comment: 'w2w funnel pride with g12 screen',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnPTmg15: {
    layout: 'own-ai-man-g',
    layoutNotes: [LAYOUT_NOTES.WelcomeG15],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.FIXED_TIMER],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-499',
    comment: 'w2w funnel pride with g15 screen',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnPTm_FlsWTg: {
    layout: 'own-ai-man-fls-tg',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.FIXED_TIMER],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2649',
    comment: 'First loader screen with tattooed guy',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnPTm_FlsWMg: {
    layout: 'own-ai-man-fls-mg',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.FIXED_TIMER],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2649',
    comment: 'First loader screen with muscle guy',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnPSt: {
    layout: 'own-ai-man',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: ['pro.1w', 'pro.1m', 'pro.1y'],
    coins: [],
    defaultPlan: 'pro.1y',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2419',
    comment: 'Man`s campaign with default plans',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnPoff: {
    layout: 'own-ai-man-paymentless',
    layoutNotes: [],
    theme: 'dark',
    paywall: null,
    paywallNotes: [],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'paymentless',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: false,
    task: 'PROD-2394',
    comment: 'Man`s paymentless campaign',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMnPc: {
    layout: 'own-ai-man',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG, PAYWALL_NOTES.PROMO_CODE],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-man',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2433',
    comment: 'Web2web for men with promo code',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedChSet: {
    layout: 'own-ai',
    layoutNotes: [LAYOUT_NOTES.PERSONALITY_VALUES],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2289',
    comment: 'create g34 campaign with updated personality screen',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedSx: {
    layout: 'own-ai',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [PAYWALL_NOTES.FOUR_NSFW_GIRL],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2282',
    comment: 'only 4 new girls on the paywall',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedSx9_19: {
    layout: 'own-ai',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [PAYWALL_NOTES.FOUR_NSFW_GIRL],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1026',
    comment: 'Replace intro offer 6.99->39.99 with a plan week for $9.99',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedSxB1: {
    layout: 'own-ai-w',
    layoutNotes: [LAYOUT_NOTES.BRETTY1],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [PAYWALL_NOTES.FOUR_NSFW_GIRL],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-812',
    comment: 'Welcome screen Bretty1',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedSxB3: {
    layout: 'own-ai-w',
    layoutNotes: [LAYOUT_NOTES.BRETTY3],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [PAYWALL_NOTES.FOUR_NSFW_GIRL],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-812',
    comment: 'Welcome screen Bretty3',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedSxO2: {
    layout: 'own-ai-w',
    layoutNotes: [LAYOUT_NOTES.OLIVIA2],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [PAYWALL_NOTES.FOUR_NSFW_GIRL],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-812',
    comment: 'Welcome screen Olivia2',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedSxX1: {
    layout: 'own-ai-w',
    layoutNotes: [LAYOUT_NOTES.XINHUA1],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [PAYWALL_NOTES.FOUR_NSFW_GIRL],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-812',
    comment: 'Welcome screen Xinhua1',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedSxWV: {
    layout: 'own-ai',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [PAYWALL_NOTES.FOUR_NSFW_GIRL],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2282',
    comment: 'only 4 new girls on the paywall',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedSxFll: {
    layout: 'own-ai',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG],
    paywallImagesVariant: 'v6-sexy',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2300',
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedSxPAp: {
    layout: 'own-ai',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs',
    paywallNotes: [PAYWALL_NOTES.FOUR_NSFW_GIRL],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2296',
    comment: 'join g34bjedPAp and g34bjedSx',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedPoff: {
    layout: 'own-ai-paymentless',
    layoutNotes: [],
    theme: 'dark',
    paywall: null,
    paywallNotes: [],
    paywallImagesVariant: null,
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'paymentless',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: false,
    task: 'PROD-2277',
    comment: 'paymentless campaign',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedPlD: {
    layout: 'own-ai',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: ['pro.1w', 'pro.1m', 'pro.1y'],
    coins: [],
    defaultPlan: 'pro.1y',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedPS: {
    layout: 'own-ai',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedPA: {
    layout: 'own-ai',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedPAp: {
    layout: 'own-ai',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs',
    paywallNotes: [],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedPApFT: {
    layout: 'own-ai',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs',
    paywallNotes: [PAYWALL_NOTES.FIXED_TIMER],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2301',
    comment: 'fixed timer on the top of a paywall',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedSrOb: {
    layout: 'own-ai',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG],
    paywallImagesVariant: 'skinny_regular_on_bed',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'PROD-2309',
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMG: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMG9_21: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_week_9_99_to_21_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1238',
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  Applvn: {
    layout: 'own-ai-multigender-safe-v2',
    layoutNotes: [
      LAYOUT_NOTES.SEND_PHOTOS_V2,
      LAYOUT_NOTES.BODY_SHAPE_SPORTS,
      LAYOUT_NOTES.SAFE_INTERACTIONS,
      LAYOUT_NOTES.EMAIL_STATIC_IMAGE,
      LAYOUT_NOTES.REVIEWS_APP_STORE,
    ],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.STORE_IMAGES,
      PAYWALL_NOTES.SAFE_PLANS_ACCESS,
      PAYWALL_NOTES.REVIEWS_APP_STORE,
    ],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
    enableAxonTracking: true,
  },
  g34bjedMG8_17: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_8_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1237',
    comment: 'New plans on paywall',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMG11_23: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1237',
    comment: 'New plans on paywall',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGwopay: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: null,
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1116',
    comment: 'Campaign with redirect to web app after email',
    hasWebAppLink: true,
    redirectToWebappAfter: 'email',
  },
  g34bjedMGweb_rd: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'web-version',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1030',
    comment: 'Campaign with redirect to web app after subscription',
    hasWebAppLink: true,
    redirectToWebappAfter: 'subscription',
  },
  g34bjedMGons14: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.ONE_DAY_VIP_SELECT_PLAN],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: ['pro.one_off_1d_14_99'],
    coins: [],
    defaultPlan: 'pro.one_off_1d_14_99',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1144',
    comment: 'All gender funnel with ONS plans',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGv1: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_week_19_99',
      'pro.rebill_month_29_99',
      'pro.rebill_3months_59_99',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_month_29_99',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1092',
    comment: 'Add new subscription plans to web funnels',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGv2: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: ['pro.rebill_2weeks_39_99', 'pro.rebill_3months_59_99'],
    coins: [],
    defaultPlan: 'pro.rebill_3months_59_99',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: 'Add new subscription plans to web funnels',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGsf: {
    layout: 'own-ai-multigender-safe',
    layoutNotes: [LAYOUT_NOTES.SEND_PHOTOS_V2, LAYOUT_NOTES.BODY_SHAPE_SPORTS],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'Safe funnel',
    comment: 'MAIN-1083',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGwwc: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.WEB_VERSION],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'web-version',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1047',
    comment: 'Funnel for web app with different congrats screen',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGwwc_9_19: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.WEB_VERSION],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'web-version',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1290',
    comment: 'Web funnel for web',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGwwc_11_23: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.WEB_VERSION],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'web-version',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1290',
    comment: 'Web funnel for web',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1046',
    comment: 'Real man photos on paywall',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGrpW11_23: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.REAL_MAN_PHOTOS,
      PAYWALL_NOTES.FIXED_TIMER_V2,
      PAYWALL_NOTES.OFFER_CARD_SELECT_PLAN,
    ],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: ['pro.rebill_1w_discount_11_99'],
    coins: [],
    defaultPlan: 'pro.rebill_1w_discount_11_99',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1739',
    comment: '',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGrpS: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: ['pro.1w_19_99', 'pro.1m_29_99'],
    coins: [],
    defaultPlan: 'pro.1m_29_99',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: 'Week $19.99 and Month $29.99 - no intro offer',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  Tg34bjedMGrp: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1438',
    comment: 'Funnel for global tests',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp9_21: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_week_9_99_to_21_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1238',
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp8_17: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_8_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1216',
    comment: 'Add new subs plans',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp_aio: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    plansByGender: {
      male: [
        'pro.rebill_1w_discount_11_99',
        'pro.rebill_1m_discount',
        'pro.rebill_3m_discount',
      ],
      female: [
        'pro.rebill_1w_discount_9_99',
        'pro.rebill_1m_discount',
        'pro.rebill_3m_discount',
      ],
    },
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1216',
    comment: 'Male = 11_23 plans, Female = 9_19 plans (plansByGender)',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp_aio_G: {
    layout: 'own-ai-multigender-aio-g',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    plansByGender: {
      male: [
        'pro.rebill_1w_discount_11_99',
        'pro.rebill_1m_discount',
        'pro.rebill_3m_discount',
      ],
      female: [
        'pro.rebill_1w_discount_9_99',
        'pro.rebill_1m_discount',
        'pro.rebill_3m_discount',
      ],
    },
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1216',
    comment:
      'aio + Identify; AI-man + user female → female-tier plans (MG9_19-style weekly)',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp_aio_3: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    plansByGender: {
      male: [
        'pro.rebill_1w_discount_11_99',
        'pro.rebill_1m_discount',
        'pro.rebill_3m_discount',
      ],
      female: [
        'pro.rebill_1w_discount_9_99',
        'pro.rebill_1m_discount',
        'pro.rebill_3m_discount',
      ],
    },
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-aio',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-000',
    comment: 'Success page with ios, android and web',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp_aio_k: {
    layout: 'own-ai-multigender',
    layoutNotes: [LAYOUT_NOTES.GENDER_KELLY],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    plansByGender: {
      male: [
        'pro.rebill_1w_discount_11_99',
        'pro.rebill_1m_discount',
        'pro.rebill_3m_discount',
      ],
      female: [
        'pro.rebill_1w_discount_9_99',
        'pro.rebill_1m_discount',
        'pro.rebill_3m_discount',
      ],
    },
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-000',
    comment: 'New first screen',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp_aio_k_shy: {
    layout: 'own-ai-multigender',
    layoutNotes: [LAYOUT_NOTES.GENDER_KELLY_SHY],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    plansByGender: {
      male: [
        'pro.rebill_1w_discount_11_99',
        'pro.rebill_1m_discount',
        'pro.rebill_3m_discount',
      ],
      female: [
        'pro.rebill_1w_discount_9_99',
        'pro.rebill_1m_discount',
        'pro.rebill_3m_discount',
      ],
    },
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-000',
    comment: 'New first screen',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp_aio_k_shy_w: {
    layout: 'own-ai-multigender',
    layoutNotes: [LAYOUT_NOTES.GENDER_KELLY_WHITE],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    plansByGender: {
      male: [
        'pro.rebill_1w_discount_11_99',
        'pro.rebill_1m_discount',
        'pro.rebill_3m_discount',
      ],
      female: [
        'pro.rebill_1w_discount_9_99',
        'pro.rebill_1m_discount',
        'pro.rebill_3m_discount',
      ],
    },
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-2097',
    comment: 'New first screen',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp11_23: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1216',
    comment: 'Add new subs plans',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp11_23TT_HM: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-000',
    comment:
      'Copy of g34bjedMGrp11_23, TT Huntermob (TT_HM) variant — pixel D9BLDKBC77U3GHS8HCMG',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp11_23_ow: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.REAL_MAN_PHOTOS,
      PAYWALL_NOTES.HOW_IT_WORKS_OPEN_APP,
    ],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-only-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: '',
    comment: 'Only web link',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp11_23_web: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: '',
    comment: '',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp14_29: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_week_14_99_to_29_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1740',
    comment: 'Week plan $14.99 rebilling to $29.99',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp11_23_t: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.REAL_MAN_PHOTOS,
      PAYWALL_NOTES.EXCLUDED_PAYMENT_METHODS_BANK,
    ],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1681',
    comment: '',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp11_23_k: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.REAL_MAN_PHOTOS,
      PAYWALL_NOTES.HIDE_APPLE_PAY_RECURRING_INFO,
    ],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1681',
    comment: 'Hide billing details from Apple Pay sheet',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMGrpam11_23: {
    layout: 'own-ai-multigender',
    layoutNotes: [LAYOUT_NOTES.TOTAL_REAL_BOYS_SCREENS],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1362',
    comment: 'Total real boys funnel',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGrpM29_59: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: ['pro.rebill_1w_discount_11_99', 'pro.rebill_month_29_99'],
    coins: [],
    defaultPlan: 'pro.rebill_month_29_99',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1238',
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGrpM29_39: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: ['pro.rebill_1w_discount_11_99', 'pro.rebill_month_29_99_to_39_99'],
    coins: [],
    defaultPlan: 'pro.rebill_month_29_99_to_39_99',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1238',
    comment: null,
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMGrpWY: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: ['pro.rebill_1w_discount_11_99', 'pro.rebill_year_79_99_to_159_99'],
    coins: [],
    defaultPlan: 'pro.rebill_year_79_99_to_159_99',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1694',
    comment: 'g34bjedMGrpM29_39 + yearly plan $79.99 → $159.99',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMGrpM29_39e: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_month_29_99_to_39_99',
      'pro.rebill_3months_59_99_to_79_99',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_month_29_99_to_39_99',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1238',
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGrpM29_39t: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.REAL_MAN_PHOTOS,
      PAYWALL_NOTES.FIXED_TIMER_SECOND_PLAN,
    ],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: ['pro.rebill_1w_discount_11_99', 'pro.rebill_month_29_99_to_39_99'],
    coins: [],
    defaultPlan: 'pro.rebill_month_29_99_to_39_99',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1238',
    comment: 'g34bjedMGrpM29_39 + fixed timer with GET MY PLAN button',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMGrpons14: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.REAL_MAN_PHOTOS,
      PAYWALL_NOTES.ONE_DAY_VIP_SELECT_PLAN,
    ],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: ['pro.one_off_1d_14_99'],
    coins: [],
    defaultPlan: 'pro.one_off_1d_14_99',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1144',
    comment: 'All gender funnel with ONS plans',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGrpa: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.REAL_MAN_PHOTOS,
      PAYWALL_NOTES.REAL_GIRLS_PHOTOS,
    ],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1108',
    comment: 'Real girls photos on paywall',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGrpa9_19: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.REAL_MAN_PHOTOS,
      PAYWALL_NOTES.REAL_GIRLS_PHOTOS,
    ],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1148',
    comment: '9_19 plan for all real photos onboarding',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp9_19: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1046',
    comment: 'Real man photos on paywall',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp9_19test: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1617',
    comment: 'Copy of g34bjedMGrp9_19 for Stripe subscription webhook test',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp9_19A: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1474',
    comment: 'Campaign for test GA(event send from front-end)',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp9_19B: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1474',
    comment: 'Campaign for test GA(event send from back-end)',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp9_19TT: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REAL_MAN_PHOTOS],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1046',
    comment: 'Copy of g34bjedMGrp9_19, TT (TikTok) variant',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMGrpan9_19: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.REAL_MAN_PHOTOS,
      PAYWALL_NOTES.REAL_GIRLS_PHOTOS_V2,
      PAYWALL_NOTES.SCALABLE_PAYWALL_IMAGE,
    ],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: ['pro.rebill_1w_discount_9_99', 'pro.1m', 'pro.3m'],
    coins: [],
    defaultPlan: 'pro.1m',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1217',
    comment: 'Real girls photos on paywall v2',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGan: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.SIMPLE_SELECT_PLAN],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: ['pro.1m', 'pro.3m', 'pro.1y'],
    coins: [],
    defaultPlan: 'pro.1y',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1034',
    comment: 'New simple select plan',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGnw: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: ['pro.rebill_1m_discount', 'pro.rebill_3m_discount'],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1002',
    comment: 'Web funnel without intro week',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGPPC1: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: true,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-922',
    comment: 'Decline prepaid cards',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGPPC2: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: true,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-922',
    comment: 'Decline prepaid cards',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34dMGons: {
    layout: 'own-ai-constructor',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.FOUR_NSFW_GIRL,
      PAYWALL_NOTES.VIP_PLANS_ACCESS,
      PAYWALL_NOTES.ONE_NIGHT_STAND,
      PAYWALL_NOTES.APP_ICON_BG,
    ],
    paywallImagesVariant: 'one-night-stand-constructor',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-constructor',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-952',
    comment: 'New ONS constructor funnel',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  CmpbTb: {
    layout: 'own-ai-compatibility',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs',
    paywallNotes: [
      PAYWALL_NOTES.ARCHETYPE,
      PAYWALL_NOTES.APP_ICON_BG,
      PAYWALL_NOTES.SCALABLE_PAYWALL_IMAGE,
    ],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1060',
    comment: 'Compatibility funnel',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  CmpbTbrp: {
    layout: 'own-ai-compatibility',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs',
    paywallNotes: [
      PAYWALL_NOTES.ARCHETYPE,
      PAYWALL_NOTES.APP_ICON_BG,
      PAYWALL_NOTES.SCALABLE_PAYWALL_IMAGE,
      PAYWALL_NOTES.ARCHETYPE_REAL_PHOTOS,
    ],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1060',
    comment: 'Compatibility funnel',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  RpLRm: {
    layout: 'own-ai-roleplay-rooms',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs',
    paywallNotes: [
      PAYWALL_NOTES.ROLEPLAY_ROOM_GIRLS,
      PAYWALL_NOTES.SCALABLE_PAYWALL_IMAGE,
    ],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1107',
    comment: 'Roleplay rooms funnel',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34dMGonsP9: {
    layout: 'own-ai-constructor',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.FOUR_NSFW_GIRL,
      PAYWALL_NOTES.VIP_PLANS_ACCESS,
      PAYWALL_NOTES.ONE_NIGHT_STAND,
      PAYWALL_NOTES.APP_ICON_BG,
      PAYWALL_NOTES.ONE_DAY_VIP_SELECT_PLAN,
    ],
    paywallImagesVariant: 'one-night-stand-constructor',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: ['pro.one_off_1d_9_99'],
    coins: [],
    defaultPlan: 'pro.one_off_1d_9_99',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-constructor',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1061',
    comment: 'ONS subscription plan paywall',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34dMGonsP14: {
    layout: 'own-ai-constructor',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.FOUR_NSFW_GIRL,
      PAYWALL_NOTES.VIP_PLANS_ACCESS,
      PAYWALL_NOTES.ONE_NIGHT_STAND,
      PAYWALL_NOTES.APP_ICON_BG,
      PAYWALL_NOTES.ONE_DAY_VIP_SELECT_PLAN,
    ],
    paywallImagesVariant: 'one-night-stand-constructor',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: ['pro.one_off_1d_14_99'],
    coins: [],
    defaultPlan: 'pro.one_off_1d_14_99',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-constructor',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1061',
    comment: 'ONS subscription plan paywall',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34dMGonsP19: {
    layout: 'own-ai-constructor',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.FOUR_NSFW_GIRL,
      PAYWALL_NOTES.VIP_PLANS_ACCESS,
      PAYWALL_NOTES.ONE_NIGHT_STAND,
      PAYWALL_NOTES.APP_ICON_BG,
      PAYWALL_NOTES.ONE_DAY_VIP_SELECT_PLAN,
    ],
    paywallImagesVariant: 'one-night-stand-constructor',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: ['pro.one_off_1d_19_99'],
    coins: [],
    defaultPlan: 'pro.one_off_1d_19_99',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'one-night-stand-constructor',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1061',
    comment: 'ONS subscription plan paywall',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMG9_19: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-894',
    comment: 'New Intro offer for new funnel',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMG9_19TT: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: false,
    task: 'MAIN-000',
    comment:
      'Copy of g34bjedMG9_19 — TikTok-only pixel (D95RTURC77U03DOJ916G), no Meta',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMG9_19_ow: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.HOW_IT_WORKS_OPEN_APP],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-only-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: '',
    comment: 'Only web link',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMG9_19_fm: {
    layout: 'own-ai-multigender-fm',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: '',
    comment: 'Copy of g34bjedMG9_19 with new id',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMG9_19_fm_G: {
    layout: 'own-ai-multigender-fm-g',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1870',
    comment: '',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMG9_19_fm_bG: {
    layout: 'own-ai-multigender-fm-bg',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1904',
    comment: '',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMG9_19test: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1617',
    comment: 'Copy of g34bjedMG9_19 for Stripe subscription webhook test',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMG9_19g2: {
    layout: 'own-ai-multigender',
    layoutNotes: [LAYOUT_NOTES.GENDER_GIRLS_2],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1451',
    comment: 'New girls on first screen(screen №2)',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMG9_19g4: {
    layout: 'own-ai-multigender',
    layoutNotes: [LAYOUT_NOTES.GENDER_GIRLS_4],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1451',
    comment: 'New girls on first screen(screen №4)',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMG9_19g5: {
    layout: 'own-ai-multigender',
    layoutNotes: [LAYOUT_NOTES.GENDER_GIRLS_5],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1451',
    comment: 'New girls on first screen(screen №5)',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  g34bjedMG9_19p: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.FIXED_TIMER_SECOND_PLAN,
      PAYWALL_NOTES.PERSONALIZED_HEADER,
    ],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-894',
    comment: 'New Intro offer for new funnel',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  kfpn6v: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-874',
    comment: 'Create identical onb g34bjedMG with new id kfpn6v',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  m8xq2p: {
    layout: 'own-ai-multigender',
    layoutNotes: [LAYOUT_NOTES.REMOVE_DIALOGUE_REFERENCES],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [PAYWALL_NOTES.REMOVE_DIALOGUE_REFERENCES],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1093',
    comment:
      'Create identical onb g34bjedMG with new id m8xq2p - removes Dialogue references',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  mftde9: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'multigender',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-888',
    comment: 'Create identical onb g34bjedMG with new id mftde9',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGUPS: {
    theme: 'dark',
    layout: 'own-ai-multigender',
    layoutNotes: [],
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [],
    paywallImagesVariant: null,
    successPage: 'default-upsale',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: ['com.pheon.coins.plan6'],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGUv1: {
    theme: 'dark',
    layout: 'own-ai-multigender',
    layoutNotes: [],
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.SHOW_COINS_PAYWALL_MODAL,
      PAYWALL_NOTES.COINS_UPSALE_V1,
    ],
    paywallImagesVariant: 'multigender',
    successPage: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: ['com.pheon.coins.plan9'],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-972',
    comment: 'Upsale with new api',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGUv2: {
    theme: 'dark',
    layout: 'own-ai-multigender',
    layoutNotes: [],
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.SHOW_COINS_PAYWALL_MODAL,
      PAYWALL_NOTES.COINS_UPSALE_V2,
    ],
    paywallImagesVariant: 'multigender',
    successPage: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: ['com.pheon.coins.plan9'],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-972',
    comment: 'Upsale with new api',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGUv3: {
    theme: 'dark',
    layout: 'own-ai-multigender',
    layoutNotes: [],
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.SHOW_COINS_PAYWALL_MODAL,
      PAYWALL_NOTES.COINS_UPSALE_V3,
    ],
    paywallImagesVariant: 'multigender',
    successPage: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: ['com.pheon.coins.plan9'],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-972',
    comment: 'Upsale with new api',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  q22mnbvc: {
    layout: 'own-ai-second',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: true,
    staticTheme: 'dark-violet',
    successPage: 'with-email',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  q22mnbvcPhVi: {
    layout: 'own-ai-second-video',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: true,
    staticTheme: 'dark-violet',
    successPage: 'with-email',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  q22mnbvcPE: {
    layout: 'own-ai-second',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs',
    paywallNotes: [],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: true,
    staticTheme: 'dark-violet',
    successPage: 'with-email',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  q22mnAof: {
    layout: 'own-ai-second',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'v6',
    paywallNotes: [],
    paywallImagesVariant: 'v6',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: 'dark-violet',
    successPage: 'with-email',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  q22mnbPoff: {
    layout: 'own-ai-second',
    layoutNotes: [],
    theme: 'dark',
    paywall: null,
    paywallNotes: [],
    paywallImagesVariant: null,
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: 'dark-violet',
    successPage: 'default',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: false,
    task: null,
    comment: null,
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  ErpMn1: {
    layout: 'own-ai-man-roleplay',
    layoutNotes: [LAYOUT_NOTES.S1],
    theme: 'dark',
    paywall: 'fast-pay-tabs-roleplay',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'roleplay',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-614',
    comment: 'Storytell w2w funnel welcome 1',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  ErpMn2: {
    layout: 'own-ai-man-roleplay',
    layoutNotes: [LAYOUT_NOTES.S2],
    theme: 'dark',
    paywall: 'fast-pay-tabs-roleplay',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'roleplay',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-614',
    comment: 'Storytell w2w funnel welcome 2',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  ErpMn3: {
    layout: 'own-ai-man-roleplay',
    layoutNotes: [LAYOUT_NOTES.S3],
    theme: 'dark',
    paywall: 'fast-pay-tabs-roleplay',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'roleplay',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-614',
    comment: 'Storytell w2w funnel welcome 3',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  ErpMn4: {
    layout: 'own-ai-man-roleplay',
    layoutNotes: [LAYOUT_NOTES.S4],
    theme: 'dark',
    paywall: 'fast-pay-tabs-roleplay',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'roleplay',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-614',
    comment: 'Storytell w2w funnel welcome 4',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  ErpMn5: {
    layout: 'own-ai-man-roleplay',
    layoutNotes: [LAYOUT_NOTES.S5],
    theme: 'dark',
    paywall: 'fast-pay-tabs-roleplay',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'roleplay',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-614',
    comment: 'Storytell w2w funnel welcome 5',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  ErpMn6: {
    layout: 'own-ai-man-roleplay',
    layoutNotes: [LAYOUT_NOTES.S6],
    theme: 'dark',
    paywall: 'fast-pay-tabs-roleplay',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'roleplay',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-614',
    comment: 'Storytell w2w funnel welcome 6',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  ErpMn6NAP: {
    layout: 'own-ai-man-roleplay-nap',
    layoutNotes: [LAYOUT_NOTES.S6],
    theme: 'dark',
    paywall: 'fast-pay-tabs-roleplay',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG],
    paywallImagesVariant: 'fast-pay-tabs-man',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'roleplay',
    hasNameAfterPaywall: true,
    postPaywallName: 'roleplay',
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-723',
    comment: 'Storytell w2w funnel with name screen after paywall',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  GfwtpsL: {
    layout: 'own-ai-man-trans-l',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG, PAYWALL_NOTES.MAIN_697],
    paywallImagesVariant: 'main-697',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: 'purple-gradient',
    successPage: 'onboarding-based',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-697',
    comment: 'Long w2w',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  GfwtpsS: {
    layout: 'own-ai-man-trans-s',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [PAYWALL_NOTES.APP_ICON_BG, PAYWALL_NOTES.MAIN_697],
    paywallImagesVariant: 'main-697',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [
      'pro.rebill_1w_discount',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: 'purple-gradient',
    successPage: 'onboarding-based',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-697',
    comment: 'Short w2w',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMG11_23Uv1: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.SHOW_COINS_PAYWALL_MODAL,
      PAYWALL_NOTES.COINS_UPSALE_V1,
    ],
    paywallImagesVariant: 'multigender',
    successPage: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: ['com.pheon.coins.plan9'],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: 'Upsale with new api - 11.99 plan',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMG11_23Uv2: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.SHOW_COINS_PAYWALL_MODAL,
      PAYWALL_NOTES.COINS_UPSALE_V2,
    ],
    paywallImagesVariant: 'multigender',
    successPage: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: ['com.pheon.coins.plan9'],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: 'Upsale with new api - 11.99 plan',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMG11_23Uv3: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.SHOW_COINS_PAYWALL_MODAL,
      PAYWALL_NOTES.COINS_UPSALE_V3,
    ],
    paywallImagesVariant: 'multigender',
    successPage: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: ['com.pheon.coins.plan9'],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: 'Upsale with new api - 11.99 plan',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp11_23Uv1: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.REAL_MAN_PHOTOS,
      PAYWALL_NOTES.SHOW_COINS_PAYWALL_MODAL,
      PAYWALL_NOTES.COINS_UPSALE_V1,
    ],
    paywallImagesVariant: 'multigender',
    successPage: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: ['com.pheon.coins.plan9'],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: 'Upsale with new api - 11.99 plan with real man photos',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp11_23Uv2: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.REAL_MAN_PHOTOS,
      PAYWALL_NOTES.SHOW_COINS_PAYWALL_MODAL,
      PAYWALL_NOTES.COINS_UPSALE_V2,
    ],
    paywallImagesVariant: 'multigender',
    successPage: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: ['com.pheon.coins.plan9'],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: 'Upsale with new api - 11.99 plan with real man photos',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  g34bjedMGrp11_23Uv3: {
    layout: 'own-ai-multigender',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.REAL_MAN_PHOTOS,
      PAYWALL_NOTES.SHOW_COINS_PAYWALL_MODAL,
      PAYWALL_NOTES.COINS_UPSALE_V3,
    ],
    paywallImagesVariant: 'multigender',
    successPage: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: ['com.pheon.coins.plan9'],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: 'Upsale with new api - 11.99 plan with real man photos',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  Maxim: {
    layout: 'own-ai-man-maxim',
    layoutNotes: [],
    theme: 'dark',
    paywall: null,
    paywallNotes: [],
    paywallImagesVariant: null,
    successPage: 'maxim',
    ai_type: 'girl',
    gender_ai_type: 'man',
    plans: [],
    coins: [],
    defaultPlan: 'pro.1y',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1435',
    comment: 'Maxim funnel',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  Maxim11_23: {
    layout: 'own-ai-man-tm',
    layoutNotes: [LAYOUT_NOTES.TM_MAXIM],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [
      PAYWALL_NOTES.TM_MAXIM_PHOTOS,
      PAYWALL_NOTES.APP_ICON_BG,
      PAYWALL_NOTES.PERSONALIZED_HEADER,
    ],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'with-steps',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: '',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  Thomas11_23: {
    layout: 'own-ai-man-tm',
    layoutNotes: [LAYOUT_NOTES.TM_THOMAS],
    theme: 'dark',
    paywall: 'fast-pay-tabs-man',
    paywallNotes: [
      PAYWALL_NOTES.TM_THOMAS_PHOTOS,
      PAYWALL_NOTES.APP_ICON_BG,
      PAYWALL_NOTES.PERSONALIZED_HEADER,
    ],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'with-steps-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: '',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  LAppg34bjedMGrp11_23: {
    layout: 'own-ai-multigender',
    layoutNotes: [
      LAYOUT_NOTES.LURE_APP_BRANDING,
      LAYOUT_NOTES.REQUIRE_TERMS_CHECKBOX,
    ],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.REAL_MAN_PHOTOS,
      PAYWALL_NOTES.APP_ICON_BG,
      PAYWALL_NOTES.LURE_APP_BRANDING,
      PAYWALL_NOTES.HIDE_APP_CAPTION,
      PAYWALL_NOTES.REQUIRE_TERMS_CHECKBOX,
    ],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'web-version',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1801',
    comment: 'Copy of LAg34bjedMGrp11_23 with legal links for lurechat.app',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
    registrationPlatform: REGISTRATION_PLATFORM.WEBAPP_LURE,
  },
  LAg34bjedMGrp11_23: {
    layout: 'own-ai-multigender-lure',
    layoutNotes: [
      LAYOUT_NOTES.LURE_AI_BRANDING,
      LAYOUT_NOTES.REQUIRE_TERMS_CHECKBOX,
    ],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.REAL_MAN_PHOTOS,
      PAYWALL_NOTES.APP_ICON_BG,
      PAYWALL_NOTES.LURE_AI_BRANDING,
      PAYWALL_NOTES.HIDE_APP_CAPTION,
      PAYWALL_NOTES.REQUIRE_TERMS_CHECKBOX,
      PAYWALL_NOTES.SHOW_SUBSCRIPTION_MANAGE_HINT,
      PAYWALL_NOTES.SHOW_COMPANY_DETAILS_FOOTER,
    ],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'web-version',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1746',
    comment: 'Add terms checkbox for reviewers',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
    registrationPlatform: REGISTRATION_PLATFORM.WEBAPP_LURE,
  },
  OnbPool: {
    layout: 'own-ai-pool',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs',
    paywallNotes: [
      PAYWALL_NOTES.APP_ICON_BG,
      PAYWALL_NOTES.POOL_GIRL_IMAGE,
      PAYWALL_NOTES.SCALABLE_PAYWALL_IMAGE,
    ],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'with-steps',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1632',
    comment: 'Onboarding with pool girl',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
  Frst11_23: {
    layout: 'own-ai-multigender-forest',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.APP_ICON_BG,
      PAYWALL_NOTES.FOREST_IMAGES,
      PAYWALL_NOTES.FOREST_TITLE,
      PAYWALL_NOTES.SCALABLE_PAYWALL_IMAGE,
    ],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_11_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'with-steps-web',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: null,
    comment: 'Forest web funnel',
    hasWebAppLink: true,
    redirectToWebappAfter: null,
  },
  Frst9_19: {
    layout: 'own-ai-multigender-forest',
    layoutNotes: [],
    theme: 'dark',
    paywall: 'fast-pay-tabs-multigender',
    paywallNotes: [
      PAYWALL_NOTES.APP_ICON_BG,
      PAYWALL_NOTES.FOREST_IMAGES,
      PAYWALL_NOTES.FOREST_TITLE,
      PAYWALL_NOTES.SCALABLE_PAYWALL_IMAGE,
    ],
    paywallImagesVariant: 'multigender',
    ai_type: 'girl',
    gender_ai_type: 'women',
    plans: [
      'pro.rebill_1w_discount_9_99',
      'pro.rebill_1m_discount',
      'pro.rebill_3m_discount',
    ],
    coins: [],
    defaultPlan: 'pro.rebill_1m_discount',
    rejectPrepaidCards: false,
    preferencesVariant: 'v1',
    animated: false,
    staticTheme: null,
    successPage: 'with-steps',
    hasNameAfterPaywall: false,
    postPaywallName: null,
    hasDisabledWeeklyPlan: false,
    canLogFBEvents: true,
    task: 'MAIN-1672',
    comment: 'Forest web funnel',
    hasWebAppLink: false,
    redirectToWebappAfter: null,
  },
};
